module.exports = __webpack_public_path__ + "static/media/1_Connect-Phone-to-Wifi-a.2e614721.svg";